import { render, staticRenderFns } from "./password.vue?vue&type=template&id=2190cae7&scoped=true"
import script from "./password.vue?vue&type=script&lang=js"
export * from "./password.vue?vue&type=script&lang=js"
import style1 from "./password.vue?vue&type=style&index=1&id=2190cae7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2190cae7",
  null
  
)

export default component.exports